import { cn } from 'lib/helpers/utility';

import Avatar from 'components/shared/Avatar/Avatar';

const SupportContactCard = ({ title, contact, className = '' }) => {
  const name = contact
    ? `${contact.firstName ?? ''} ${contact.lastName ?? ''}`.trim()
    : 'Not assigned yet';

  return (
    <div className={cn('rounded-lg border border-solid border-neutral-200 p-5', className)}>
      {contact ? (
        <div className="flex flex-col gap-4">
          <Avatar
            firstName={contact.firstName}
            lastName={contact.lastName}
            id={contact.id}
            image={contact.profile_picture}
            size="xl"
            isSquare={false}
          />
          <div className="font-500 text-neutral-900">{name}</div>
          <div className="text text-sm font-400 text-neutral-700">{title}</div>
        </div>
      ) : (
        <>
          <div className="font-500 text-neutral-900">{title}</div>
          <p className="text text-sm font-400 text-neutral-700">Not assigned yet!</p>
        </>
      )}
    </div>
  );
};

export default SupportContactCard;
